import * as FileSaver from "file-saver";
import * as XLSX from "xlsx"
import { toast } from 'react-toastify'
import Moment from 'moment';
import moment from "moment";

export function isNumber(val) {
    return !(isNaN(val));
}
export function isNumberWithoutDecimal(val) {
    return !(isNaN(val)) && !(val.includes("."));
}

const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

export function exportToExcel(Data, typeofdata, fileName) {
    let jsonData = Data;
    if (typeofdata === "csvdata") {
        jsonData = csvToJSON(Data);
    }
    const ws = XLSX.utils.json_to_sheet(jsonData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
};

export function csvToJSON(csvData) {
    const row = csvData.split('\r');
    let result = [];
    const headers = row[0].split(",");
    for (var i = 1; i < row.length; i++) {
        const obj = {};
        if (row[i]) {
            const currentlines = row[i].split(",");
            for (var j = 0; j < headers.length; j++) {
                obj[headers[j]] = currentlines[j];
            }
            result.push(obj);
        }
    }
    return result;
}

export function sortByProperty(property) {
    return function (a, b) {
        if (a[property] > b[property])
            return 1;
        else if (a[property] < b[property])
            return -1;

        return 0;
    }

}


export function getSelectedCurrentWeekDate() {
    let startdate = Moment().subtract('6', 'days').toDate();
    let enddate = Moment().toDate();
    const dates = sessionStorage.selecteddate;
    if (dates)
        return dates;
    return Moment(startdate).format("MM/DD/YYYY") + " - " + Moment(enddate).format("MM/DD/YYYY");

}

export function getCurrentWeekDate(lastEndDay='6') {
    let startdate = Moment().subtract(lastEndDay,'days').toDate();
    let enddate = Moment().toDate();
    const dates = sessionStorage.selecteddate;
    if (dates) {
        const date = dates.split(" - ");
        return Moment(date[0]).format("YYYY-MM-DD") + " - " + Moment(date[1]).format("YYYY-MM-DD");
    }
    return Moment(startdate).format("YYYY-MM-DD") + " - " + Moment(enddate).format("YYYY-MM-DD");
}

export const startDate = getCurrentWeekDate().split(" - ")[0] + "T00:00:00.00Z";
export const endDate = getCurrentWeekDate().split(" - ")[1] + "T23:59:59.00Z";

export const getJsonData = (userContext, showVioCreationDate = false) => {
    const { plaza, userType } = userContext;
    const val = sessionStorage.selectedplaza;
    const plazaList = val ? val : plaza || [];
    const isSpUser = userType === 'SP';
    const dateType = (sessionStorage.selecteddatetype === 'ViolationCreationDate' && !showVioCreationDate) ? "ReaderReadTime" : (sessionStorage.selecteddatetype || "ReaderReadTime")

    return {
        plazaIds: (plazaList?.includes("*") && isSpUser) || (!val && isSpUser) ? '""' : plazaList,
        startDate: getCurrentWeekDate().split(" - ")[0] + "T00:00:00.00Z",
        endDate: getCurrentWeekDate().split(" - ")[1] + "T23:59:59.00Z",
        dateType: dateType,
    }
}

// Function for validate file Size or Type
export function validateFileTypeAndSize(file, type, size) {
    if (file.length > 0) {
        if (type === 'excel') {
            if (file[0].type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" && file[0].type !== "application/vnd.ms-excel") {
                toast.warning("Please upload valid extention (xls/xlsx) file!");
                return false;
            }
        } else if (type === 'image') {
            var t = file[0].type.split('/').pop().toLowerCase();
            if (t !== "png" && t !== "jpg" && t !== "jpeg") {
                toast.warning("Please select a valid image type(png/jpg/jpeg) file!");
                return false;
            }
            return true;
        }
        const fileSize = file[0].size / 1024 / 1024; // in MiB
        if (fileSize > size) {
            toast.warning("File size exceeds " + size + " MB");
            return false;
            // $(file).val(''); //for clearing with Jquery
        }
        return true;
    } else {
        return false;
    }
}

export function clearStorage() {
    //localStorage.clear();
    //sessionStorage.clear();
}

export const compareDateWiseData=(currentDate, previousDate)=>{
  let {cases, sumAmount} = currentDate;
  let {date,cases:pCases,sumAmount:pSumAmount} = previousDate;

    let casePercentage = 100-((pCases/cases) * 100);
    let amountPercentage = 100-((pSumAmount/sumAmount) * 100)

  return {
     date: date,
     cases: pCases,
     sumAmount: Number(pSumAmount).toFixed(2),
     casesPer: { value: Math.abs(casePercentage), status: casePercentage < 0 ? "up" : "down" },
     amtPer: { value: Math.abs(amountPercentage.toFixed(2)), status: amountPercentage < 0 ? "up" : "down" },
  }
}
 
//-------- function for comma seprated values------
export const numberWithCommas = (amt, fractionDigit=0) => {
    amt = +amt || 0;
    return amt.toLocaleString('en-IN',{minimumFractionDigits:fractionDigit});
  };



  export const validateFileFormat =(files)=> {
    let names = [];
    let docs =  [];
    let invalidext = [];
    for(let i=0; i<files.length; i++){
    let ext = files[i].name?.split(".").pop()
    ext = ext.toLowerCase();
    let valid = true
     switch (ext) {
//        case  'pdf' :
       case  'jpg' :
       case  'jpeg' :
//        case  'tif' :
//        case  'zip' :
//        case  '7z' :
       case  'png' :
         break;
       default:
         valid = false
     }
     if(valid){
      names.push(files[i].name)
      docs.push(files[i])
      
     } else {
      invalidext.push(" ."+ext);
     }
    }
    let uniqExt = [...new Set(invalidext)]
    if(uniqExt.length>0) 
    toast.warning("Please select a valid image type(png/jpg/jpeg) file!");
  
    return {names,docs}
  }

  export const getLastNDayArr = (fromDate = new Date(), nDays = 5, subtract, format = "DD") => {
        let arr = [];
        for (let i = 0; i < nDays; i++)
          arr.push(moment(fromDate).subtract(i, subtract).format(format));
        return arr.reverse();
      };

